import { HTTP_TOKEN } from "./http";

export const getCustomFields = (params) => {
  return HTTP_TOKEN.get("customfield", { params }).then((result) => {
    return result.data;
  });
};

export const createCustomField = (data) => {
  return HTTP_TOKEN.post("customfield", data).then((result) => {
    return result.data;
  });
};


export const updateCustomField = (customfield_id, data) => {
  return HTTP_TOKEN.put(`customfield/${customfield_id}`, data).then((result) => {
    return result.data;
  });
};

export const removeCustomField = (customfield_id) => {
  return HTTP_TOKEN.delete(`customfield/${customfield_id}`).then((result) => {
    return result.data;
  });
};
